import React, {memo} from 'react';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

const FETCH_ADRIATIC = gql`
    query adriaticFeed($sku: String!){
        adriaticFeed(sku: $sku)
    }
`;

const adriatic_enabledBrands = ["WHIRLPOOL"]

const Adriatic = ({brand, sku, setHasFeed}) => {
    if(!adriatic_enabledBrands.includes(brand)){
        return <></>
    }

    const {data, loading} = useQuery(FETCH_ADRIATIC, { fetchPolicy: "cache-first", variables: { sku: sku } });
    if(loading){
        // TODO: Add loader
        return <></>
    }

    const html = data && data.adriaticFeed || "";

    // Trigger the "more info button"
    if (html) {
        setHasFeed(true);
    }

    return <div dangerouslySetInnerHTML={{__html: html}} />
}

export default memo(Adriatic);
